module.exports = __webpack_public_path__ + "assets/word_mango_default.2d6cc689.svg";